import { CreateTranslationsParams, CheckTranslationInProgressParams } from "../types/requestInputs";
import { CheckTranslationInProgressResponse } from "../types/requestsOutputs";
import { MessageResponse } from "../types/types";
import { fetchAPI } from "./utils";
import { GetQueueAIParams } from "../types/requestInputs";
import { GetQueueAIResponse } from "../types/requestsOutputs";

// Create AI-based translations
export const createTranslations = async ({
    token,
    projectId,
    language,
    selectedOption,
    translationData,
    translationType,
}: CreateTranslationsParams): Promise<MessageResponse> => {
    return fetchAPI<MessageResponse>(
        "/translate",
        "POST",
        { projectId, language, selectedOption, translationTab: translationData, translationType },
        token,
    );
};

// Check if there are translations in progress
export const checkTranslationInProgress = async ({
    token,
    since,
}: CheckTranslationInProgressParams): Promise<CheckTranslationInProgressResponse> => {
    const query = since ? `?since=${encodeURIComponent(since)}` : "";
    return fetchAPI<CheckTranslationInProgressResponse>(`/get-user-queued-items${query}`, "GET", undefined, token);
};

// Translate cartel content
export const translateCartel = async ({
    token,
    projectId,
    language,
    selectedOption,
    targetLanguages,
}: {
    token: string;
    projectId: string;
    language: string;
    selectedOption: string[];
    targetLanguages: string[];
}): Promise<MessageResponse> => {
    return fetchAPI<MessageResponse>(
        "/translate-cartel",
        "POST",
        { projectId, language, selectedOption, targetLanguages },
        token,
    );
};

// Translate newsletter content
export const translateNewsletter = async ({
    token,
    projectId,
    language,
    selectedOption,
    targetLanguages,
}: {
    token: string;
    projectId: string;
    language: string;
    selectedOption: string[];
    targetLanguages: string[];
}): Promise<MessageResponse> => {
    return fetchAPI<MessageResponse>(
        "/translate-newsletter",
        "POST",
        { projectId, language, selectedOption, targetLanguages },
        token,
    );
};

export const getUserTranslations = async ({
    token,
    page = 1,
    limit = 50,
}: Omit<GetQueueAIParams, "companyId">): Promise<GetQueueAIResponse> => {
    return fetchAPI<GetQueueAIResponse>("/get-user-translations", "POST", { page, limit }, token);
};
